import { useEffect, useRef, useState } from 'react';

import windowResize from 'utils/windowResize.util';

// This is to avoid unnecessary call to "setHeight" function
const useStickyTotalHeight = () => {
  const [localSetHeightFlag, updateSetHeightFlag] = useState(false);

  const [stickyTotalHeight, setStickyTotalHeight] = useState();
  const stickyTotalEl = useRef<HTMLDivElement>(null);

  const setHeight = () => {
    if (stickyTotalEl.current) {
      setStickyTotalHeight(stickyTotalEl.current.scrollHeight);

      if (!localSetHeightFlag) {
        updateSetHeightFlag(true);
      }
    }
  };

  useEffect(() => {
    if (!localSetHeightFlag) {
      setHeight();
    }
  });

  useEffect(() => {
    const detachCB = windowResize(setHeight);
    return detachCB;
  });

  return [stickyTotalEl, stickyTotalHeight];
};

export default useStickyTotalHeight;
